import React from "react";
import TextInput from "./TextInput";
import Trans from "../helper/Trans";

function DocumentItem(props) {
  const stepNo = props.data.step_did;
  let reqCols = [];
  reqCols.push("path");
  
  return (
    <div>
      <h5>
        {props.data.name}
      </h5>
      <p>
        {props.data.moredetail}
      </p>
      <div className="row">
        
            <div className="col-md-12">
              <div className="form-group">
                <label className="control-label" htmlFor="path">
                  {props.colNames.path}
                </label>
                <input
                  type="file"
                  id="path"
                  name="path"
                  onChange={(event) => props.onImageChange(event, stepNo)}
                  className={` ${
                    props.errors[stepNo] && props.errors[stepNo]["path"]
                      ? "is-invalid"
                      : ""
                  }`}
                />
                <div className="invalid-feedback">
                  {props.errors[stepNo] && props.errors[stepNo]["path"]}
                </div>
              </div>
            </div>
            <div className="col-md-12">
            <TextInput
              name="detail"
              id="detail"
              label={Trans("Additional Detail")}
              value={props.data.detail}
              handleInputChange={(event) =>
                props.handleInputChange(event, stepNo)
              }
              reqCols={reqCols}
              errors={props.errors[stepNo]}
              length={100}
            />
          </div>
            <div className="col-md-2">
              {props.img && props.img !== "" ? (
                <img
                  src={props.img}
                  height="150px"
                  width="150px"
                  className={`thumbnail mb-3 `}
                  alt=""
                />
              ) : (
                <></>
              )}
            </div>
          
      </div>
      <hr/>
    </div>
  );
}

export default DocumentItem;
